module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }],
    attrs: {
      "href": "/#/login"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('title')))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isA),
      expression: "!isA"
    }],
    attrs: {
      "href": "/#/hcpLogin"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "-21px"
    }
  }, [_vm._v(_vm._s(_vm.$t('title1')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d664cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common-template/Signheader.vue
// module id = 1439
// module chunks = 7